import React, { useMemo } from "react";
import { useState } from "./hooks/useState";
import Error from "./Error";
import PersonalNumberForm from "./PersonalNumberForm";
import PersonalNumberDetails from "./PersonalNumberDetails";
import ReportReturn from "./ReportReturn";
import ReportAbsence from "./ReportAbsence";
import SuccessPage from "./SuccessPage";

function SickReportV2() {
  const { error, personalNumber, formType, successType } = useState();
  const isAbsence = useMemo(() => formType === "Sick", [formType]);
  const isReturn = useMemo(
    () => formType === "RecoverySick" || formType === "RecoveryVab",
    [formType]
  );
  const isSuccess = useMemo(() => !!successType, [successType]);

  return error ? (
    <Error />
  ) : (
    <>
      {!personalNumber && !isSuccess && <PersonalNumberForm />}
      {personalNumber && !isSuccess && <PersonalNumberDetails />}
      {personalNumber && isAbsence && !isSuccess && <ReportAbsence />}
      {personalNumber && isReturn && !isSuccess && <ReportReturn />}
      {isSuccess && <SuccessPage />}
    </>
  );
}

export default SickReportV2;
